import { gql } from 'graphql-request';

export const productFractionedGql = gql`
    configPriceFractioned {
      family: productFamily
      value: productType
      showPriceLabel
      typeUnit: productTypeUnit
      showPriceUnit
    }
`;

export type TFractionedPrice = {
  active: boolean;
  name: string;
  value: string;
  typeUnit: string;
  showPriceLabel: boolean;
  showPriceUnit: boolean;
};
